module.exports = __webpack_public_path__ + "static/media/symblox-logo.578aa3e0.png";